module.exports = __webpack_public_path__ + "assets/img/powershell.ceef8533.svg";